import React, { useEffect, useState } from 'react'
import { PropTypes } from 'prop-types'
import { ReactSwitch, ReactSwitchButton, ReactSwitchCheckbox, ReactSwitchLabel } from './Filter.styles'

export default function FilterSwitch({ filter, index, handleChange, checkedArray }) {
	const [isChecked, setIsChecked] = useState(false)

	useEffect(() => {
		if (checkedArray.length === 0) {
			setIsChecked(false)
		}
	}, [checkedArray])

	function flipIt() {
		return checkedArray.includes(filter.value)
	}

	const checkIt = () => {
		setIsChecked(!isChecked)
	}

	return (
		<ReactSwitch>
			<ReactSwitchLabel
				htmlFor={`${index}_${filter.value}`}
				className={isChecked ? `switched ${filter.value}` : `${filter.value}`}
			>
				<ReactSwitchCheckbox
					key={`${index}_${filter.value}`}
					type="checkbox"
					checked={isChecked}
					id={`${index}_${filter.value}`}
					onClick={() => handleChange(filter.value)}
					onChange={(flipIt, checkIt)}
				/>
				<ReactSwitchButton className={isChecked ? `selected ${filter.value}` : `${filter.value}`} />
			</ReactSwitchLabel>
			<p>{filter.title}</p>
		</ReactSwitch>
	)
}

FilterSwitch.propTypes = {
	filter: PropTypes.object,
	index: PropTypes.number,
	handleChange: PropTypes.func,
	checkedArray: PropTypes.array,
}
